import type { JSX } from 'react';

import { SetupFramework } from '../../setup/SetupFramework';

/**
 * 设置分区。
 *
 * 这一层只做挂载：子页框架、参数会话与弹窗宿主都在 `src/setup/` 下
 * （`SetupFramework.tsx` 是入口）。把内容堆在这里，会让"分区的路由"与"分区的功能"
 * 长在同一个文件里，两边都越来越难改。
 */
export function SetupSection(): JSX.Element {
  return <SetupFramework />;
}
